import type { Absence, AbsenceStatus, AbsenceType, EmploymentType, Role, SiteStatus } from './types';

/** Anzeigetexte an einer Stelle — die Oberfläche ist durchgängig deutsch. */

export const ABSENCE_LABELS: Record<AbsenceType, string> = {
  urlaub: 'Urlaub',
  krank: 'Krank',
  frei: 'Frei',
  schule: 'Berufsschule',
  sonstiges: 'Sonstiges',
};

export const ABSENCE_SHORT: Record<AbsenceType, string> = {
  urlaub: 'URL',
  krank: 'KR',
  frei: 'FREI',
  schule: 'BS',
  sonstiges: 'SO',
};

/** CSS-Variablen-Namen je Abwesenheitsart (siehe tokens.css). */
/** Ein Buchstabe fuer sehr enge Felder — in der Verfuegbarkeits-Matrix. */
export const ABSENCE_LETTER: Record<AbsenceType, string> = {
  urlaub: 'U',
  krank: 'K',
  frei: 'F',
  schule: 'B',
  sonstiges: 'S',
};

export const ABSENCE_COLOR: Record<AbsenceType, string> = {
  urlaub: 'var(--abs-urlaub)',
  krank: 'var(--abs-krank)',
  frei: 'var(--abs-frei)',
  schule: 'var(--abs-schule)',
  sonstiges: 'var(--abs-sonstiges)',
};

export const ABSENCE_COLOR_SOFT: Record<AbsenceType, string> = {
  urlaub: 'var(--abs-urlaub-soft)',
  krank: 'var(--abs-krank-soft)',
  frei: 'var(--abs-frei-soft)',
  schule: 'var(--abs-schule-soft)',
  sonstiges: 'var(--abs-sonstiges-soft)',
};

export const ABSENCE_STATUS_LABELS: Record<AbsenceStatus, string> = {
  beantragt: 'Beantragt',
  genehmigt: 'Genehmigt',
  abgelehnt: 'Abgelehnt',
};

export const SITE_STATUS_LABELS: Record<SiteStatus, string> = {
  geplant: 'Geplant',
  aktiv: 'Aktiv',
  pausiert: 'Pausiert',
  abgeschlossen: 'Abgeschlossen',
};

export const EMPLOYMENT_LABELS: Record<EmploymentType, string> = {
  vollzeit: 'Vollzeit',
  teilzeit: 'Teilzeit',
  azubi: 'Auszubildender',
  aushilfe: 'Aushilfe',
  gewerblich: 'Gewerblich',
};

export const ROLE_LABELS: Record<Role, string> = {
  admin: 'Administrator',
  planer: 'Planer',
  betrachter: 'Betrachter',
};

export const ROLE_HINTS: Record<Role, string> = {
  admin: 'Darf alles, einschließlich Benutzerverwaltung und Sicherungen.',
  planer: 'Darf planen und alle Stammdaten pflegen.',
  betrachter: 'Darf ausschließlich lesen.',
};

/** Farbvorschläge für Kolonnen und Baustellen — abgestimmt, nicht beliebig. */
export const PALETTE = [
  '#d4500a',
  '#b45309',
  '#0f766e',
  '#0369a1',
  '#1d4ed8',
  '#6d28d9',
  '#a21caf',
  '#be123c',
  '#4d7c0f',
  '#57534e',
  '#0c0c0d',
  '#78716c',
] as const;

export const HALF_DAY_LABELS = {
  vormittag: 'Nur vormittags',
  nachmittag: 'Nur nachmittags',
} as const;

/**
 * Warum jemand nicht verfuegbar ist — Art, Status und die eingetragene
 * Begruendung in einem Satz. Wird im Plan beim Ueberfahren angezeigt, damit
 * niemand erst in die Verfuegbarkeiten wechseln muss.
 */
export function absenceReason(absence: Absence): string {
  const status = absence.status === 'genehmigt' ? '' : ` (${ABSENCE_STATUS_LABELS[absence.status]})`;
  const note = absence.note ? ` — ${absence.note}` : '';
  const half = absence.halfDay ? `, nur ${HALF_DAY_LABELS[absence.halfDay]}` : '';
  return `${ABSENCE_LABELS[absence.type]}${status}${half}${note}`;
}
